import { format, parse, addMinutes, parseISO } from 'date-fns';

// Format date to YYYY-MM-DD (backend format)
export const formatDateForBackend = (date: Date | string): string => {
  if (!date) return '';
  const d = typeof date === 'string' ? new Date(date) : date;
  return format(d, 'yyyy-MM-dd');
};

// Format date for display (DD/MM/YYYY)
export const formatDateForDisplay = (date: Date | string): string => {
  if (!date) return '';
  const d = typeof date === 'string' ? new Date(date) : date;
  return format(d, 'dd/MM/yyyy');
};

// Parse date string in DD/MM/YYYY format to Date object
export const parseDisplayDate = (dateStr: string): Date => {
  return parse(dateStr, 'dd/MM/yyyy', new Date());
};

// Format time to HH:MM
export const formatTime = (date: Date | string): string => {
  if (!date) return '';
  const d = typeof date === 'string' ? new Date(`2000-01-01T${date}`) : date;
  return format(d, 'HH:mm');
};

// Parse time string in HH:MM format to Date object
export const parseTime = (timeStr: string): Date => {
  return parse(timeStr, 'HH:mm', new Date());
};

// Combine date and time into a single Date object
export const combineDateTime = (date: Date, timeStr: string): Date => {
  const time = parseTime(timeStr);
  const result = new Date(date);
  result.setHours(time.getHours(), time.getMinutes());
  return result;
};

// Format date and time for display (DD/MM/YYYY HH:MM)
export const formatDateTime = (date: Date | string): string => {
  if (!date) return '';
  const d = typeof date === 'string' ? new Date(date) : date;
  return format(d, 'dd/MM/yyyy HH:mm');
};

// Format date and time for backend (YYYY-MM-DDTHH:mm:ss)
export const formatDateTimeForBackend = (date: Date | string): string => {
  if (!date) return '';
  const d = typeof date === 'string' ? new Date(date) : date;
  return format(d, "yyyy-MM-dd'T'HH:mm:ss");
};
